<template>
  <div class="confirm">
    <div class="confirm__overlay" v-if="modalVisible" @click.self="handleClose">
      <div class="confirm__content">
        <img src="../assets/img/login-logo.svg" alt="Logo" class="confirm__logo">
        <h2 class="confirm__title">{{ modalTitle }}</h2>
        <p class="confirm__text">{{ modalMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ConfirmView',
  data() {
    return {
      modalVisible: false,
      modalTitle: '',
      modalMessage: '',
      email: this.$route.query.email || '', // Получаем email из параметров запроса
    };
  },
  methods: {
    async confirmRegistration() {
      const user_id = this.$route.params.user_id; // Получаем user_id из параметров URL
      const code = this.$route.params.code; // Получаем код из параметров URL

      // Проверяем, есть ли user_id и code
      if (this.$route.query.email){
        this.modalVisible = true;
        this.modalTitle = 'Регистрация';
        this.modalMessage = `На почту ${this.email} отправлено письмо со ссылкой-приглашением. Перейдите по ссылке для завершения регистрации.`;
        return;
      }
      if (!user_id || !code) {
        this.modalVisible = true;
        this.modalTitle = 'Ошибка';
        this.modalMessage = 'Необходимые параметры не переданы.';
        return;
      }

      try {
        // Формируем URL с user_id и code в формате /api/pis/v1/user/confirm/{user_id}/{code}
        const response = await axios.post(`/api/pis/v1/user/confirm/${user_id}/${code}`);

        if (response.status === 200) {
          // Успешное подтверждение, сохраняем данные и перенаправляем на главную страницу
          // const userData = response.data;
          this.$router.push('/');
        }
      } catch (error) {
        this.modalVisible = true;

        // Проверяем тип ошибки с использованием $type
        const errorType = error.response?.data?.$type;

        if (errorType === 'UserAlreadyConfirmedError') {
          this.modalTitle = 'Ошибка регистрации';
          this.modalMessage = 'Пользователь уже зарегистрирован';
        } else if (errorType === 'IncorrectCodeError') {
          this.modalTitle = 'Неверная ссылка';
          this.modalMessage = 'Не удалось завершить регистрацию. Ссылка, отправленная на почту, неверная';
        } else if (errorType === 'RegistrationCodeExpiredError') {
          this.modalTitle = 'Ссылка устарела';
          this.modalMessage = 'Не удалось завершить регистрацию. Ссылка, отправленная на почту, устарела';
        }
      }
    },



    handleClose() {
      this.modalVisible = false;
      this.$router.push('/signup'); // Возвращаем пользователя на страницу регистрации
    },
  },
  mounted() {
    this.confirmRegistration();
  },
};
</script>

<style scoped>
.confirm {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/img/signup-bg.png");
  background-position: center;
}

.confirm__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm__content {
  background-color: #fff;
  padding: 24px;
  border-radius: 16px;
  width: 400px;
  text-align: center;
}

.confirm__title {
  margin-top: 25px;
  color: #333333;
  font-size: 32px;
  line-height: 18px;
  font-weight: 600;
}

.confirm__text {
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #E0E0E0;
  font-size: 20px;
  margin-bottom: 20px;
  color: #333333;
}
</style>